import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '@/features/dialog/dialogSlice';
import { FolioDrawer } from '@/components/Drawers/FolioDrawer';
import { BrokerageProfileForm } from './BrokerageProfileForm';

export const BrokerageProfileDrawer = () => {
	const dispatch = useDispatch();

	const open = useSelector((state) => state.dialog?.open?.brokerageProfile) ?? false;
	const dialogData = useSelector((state) => state.dialog?.data?.brokerageProfile);
	const docId = dialogData?.docId;

	const handleClose = () => {
		dispatch(closeDialog('brokerageProfile'));
	};

	return (
		<FolioDrawer open={open} onClose={handleClose}>
			{open && <BrokerageProfileForm docId={docId} drawerView />}
		</FolioDrawer>
	);
};

export default BrokerageProfileDrawer;
